export default __webpack_public_path__ + "static/telemed-link-0247c2f77043309ac404be13664cf169.jpg";